module.exports = __webpack_public_path__ + "static/media/react.a31bf6d6.svg";